

import * as React from "react"
import * as RadioGroupPrimitive from "@radix-ui/react-radio-group"
import { CircleIcon } from "lucide-react"

import { cn } from "@/lib/utils"

function RadioGroup({
  className,
  ...props
}: React.ComponentProps<typeof RadioGroupPrimitive.Root>) {
  return (
    <RadioGroupPrimitive.Root
      data-slot="radio-group"
      className={cn("vtwo:grid vtwo:gap-3", className)}
      {...props}
    />
  )
}

function RadioGroupItem({
  className,
  ...props
}: React.ComponentProps<typeof RadioGroupPrimitive.Item>) {
  return (
    <RadioGroupPrimitive.Item
      data-slot="radio-group-item"
      className={cn(
        "vtwo:border-input vtwo:text-primary vtwo:focus-visible:border-ring vtwo:focus-visible:ring-ring/50 vtwo:aria-invalid:ring-destructive/20 vtwo:dark:aria-invalid:ring-destructive/40 vtwo:aria-invalid:border-destructive vtwo:dark:bg-input/30 vtwo:aspect-square vtwo:size-4 vtwo:shrink-0 vtwo:rounded-full vtwo:border vtwo:shadow-xs vtwo:transition-[color,box-shadow] vtwo:outline-none vtwo:focus-visible:ring-[3px] vtwo:disabled:cursor-not-allowed vtwo:disabled:opacity-50",
        className
      )}
      {...props}
    >
      <RadioGroupPrimitive.Indicator
        data-slot="radio-group-indicator"
        className="vtwo:relative vtwo:flex vtwo:items-center vtwo:justify-center"
      >
        <CircleIcon className="vtwo:fill-primary vtwo:absolute vtwo:top-1/2 vtwo:left-1/2 vtwo:size-2 vtwo:-translate-x-1/2 vtwo:-translate-y-1/2" />
      </RadioGroupPrimitive.Indicator>
    </RadioGroupPrimitive.Item>
  )
}

export { RadioGroup, RadioGroupItem }
